import React from 'react';

type TGridListToggle = {
    isGridView: boolean;
    setIsGridView: React.Dispatch<React.SetStateAction<boolean>>;
}

const GridListToggle = ({isGridView, setIsGridView} : TGridListToggle) => {
    
    const toggleGridView = () => {
        setIsGridView(true);
    };

    const toggleListView = () => {
        setIsGridView(false);
    }

    return (
        <div className="tw-flex tw-items-center tw-bg-white tw-rounded-md tw-shadow-md">
            <button
                className={`tw-flex tw-items-center tw-px-3 tw-py-2 tw-rounded-l-md tw-transition tw-duration-100 ${
                    isGridView ? 'tw-bg-[#4949cf] tw-text-white' : 'tw-bg-white tw-text-gray-600'
                }`}
                onClick={toggleGridView}
            >
                <svg className='tw-w-5 tw-h-5 tw-mr-2' xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none" stroke="currentColor" >
                    <path d="M7.54602 2.25H2.29602V7.5H7.54602V2.25Z"/>
                    <path d="M15.796 2.25H10.546V7.5H15.796V2.25Z" />
                    <path d="M15.796 10.5H10.546V15.75H15.796V10.5Z" />
                    <path d="M7.54602 10.5H2.29602V15.75H7.54602V10.5Z" />
                </svg>
                Grid View
            </button>
            <button
                className={`tw-flex tw-items-center tw-px-3 tw-py-2 tw-rounded-r-md tw-transition tw-duration-100 ${
                    !isGridView ? 'tw-bg-[#4949cf] tw-text-white' : 'tw-bg-white tw-text-gray-600'
                }`}
                onClick={toggleListView}
            >
                <svg className='tw-w-5 tw-h-5 tw-mr-2' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="list (3) 1">
                        <path id="Vector" d="M6 4.5H15.75" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                        <path id="Vector_2" d="M6 9H15.75" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                        <path id="Vector_3" d="M6 13.5H15.75" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                        <path id="Vector_4" d="M2.25 4.5H2.2575" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path id="Vector_5" d="M2.25 9H2.2575" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path id="Vector_6" d="M2.25 13.5H2.2575" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </g>
                </svg>
                List View
            </button>
        </div>
    );
};

export default GridListToggle;